import { ServerStock, ServerStoreStock } from '@/lib/janitsjar/Product';
import { useCurrentStoreStock } from '@/cataloguePages/productPageWithVariants/helpers';
import ProductStatus from '@/cataloguePages/productPageWithVariants/components/ProductStatus';

type Props = {
  storeName: string | null;
  storeStock: ServerStoreStock | undefined;
  showStoreName?: boolean;
};

export default function StoreStock({
  storeName,
  storeStock,
  showStoreName = true,
}: Props) {
  if (!storeStock || !storeName) return null;

  const shortStoreName = showStoreName
    ? `${storeName.replace('Fagmøbler ', '')}:`
    : '';

  if (!storeStock.availableToOrder && storeStock.stock < 1) {
    return (
      <ProductStatus
        badgeVariant="primaryDark"
        badgeText={`${shortStoreName} ${storeStock.reasonText ?? 'Utsolgt'}`}
      />
    );
  }

  if (storeStock.stock < 1) {
    const availabilityText = storeStock.stockText ? (
      <span className="body-xs text-neutral-70">
        - Estimert leveringstid: {storeStock.stockText}
      </span>
    ) : null;
    return (
      <ProductStatus badgeVariant="warningNeutral">
        {shortStoreName} Bestillingsvare {availabilityText}
      </ProductStatus>
    );
  }

  return (
    <ProductStatus
      badgeVariant="successDark"
      badgeText={`${shortStoreName} ${
        storeStock.stock > 10 ? '10+' : storeStock.stock
      } på lager`}
    />
  );
}
